import axios from 'axios';

const NON_RETRYABLE_STATUSES = new Set([400, 401, 403, 404, 405, 409, 410, 422]);

const RETRYABLE_STATUSES = new Set([408, 429, 502, 503, 504]);

export const isRetryableError = (error: unknown): boolean => {
  // Non-Axios errors (e.g. programming bugs) are not retried.
  if (!axios.isAxiosError(error)) return false;

  const status = error.response?.status;

  // No response: the request never reached the server (network error) — retry.
  if (typeof status !== 'number') return true;

  if (NON_RETRYABLE_STATUSES.has(status)) return false;
  if (RETRYABLE_STATUSES.has(status) || status >= 500) return true;

  return false;
};
